import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./info-md.svg?react";

export const InfoMdIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
